export default __webpack_public_path__ + "static/media/kottu-king-coming-soon.3fdefa5b.jpg";